import { render, staticRenderFns } from "./KYC.vue?vue&type=template&id=4d3cb54e&scoped=true"
import script from "./KYC.vue?vue&type=script&lang=js"
export * from "./KYC.vue?vue&type=script&lang=js"
import style0 from "./KYC.vue?vue&type=style&index=0&id=4d3cb54e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3cb54e",
  null
  
)

export default component.exports